import Phase from "./Phase.jsx";
import { Text, View } from "@react-pdf/renderer";
import Html from "react-pdf-html";
import Helper from "../functions/Helper.js";
import linkifyHtml from "linkify-html";
import { pdfFont } from "./utils.js";

export default function Play({
  id,
  cols,
  court,
  courtColor,
  description,
  fontSizes,
  framePadding,
  frameWidth,
  maxHeight,
  objectSizeFactor,
  pageWidth,
  paddingWidth,
  phases,
  printPhaseDescriptions,
  printPhaseTitles,
  printPlayDescriptions,
  stylesheet,
  title,
  pageBreakAfterPlay = false,
}) {
  return (
    <View break={pageBreakAfterPlay}>
      {/*
      I want the title, description, and phases to be on the same page.
      However, when the the description is too long, it will be wrapped. (otherwise the descirption 
      */}
      <View wrap={(description?.length ?? 0) > 500}>
        <View style={{ marginBottom: 10 }}>
          <Text
            bookmark={title}
            id={id}
            style={{
              fontFamily: pdfFont,
              fontSize: fontSizes.objectTitle,
              fontWeight: "bold",
            }}
          >
            {title}
          </Text>
        </View>
        {printPlayDescriptions && description && (
          <View>
            <Html
              style={{ fontSize: 12, fontFamily: pdfFont }}
              stylesheet={stylesheet(fontSizes.play)}
            >
              {linkifyHtml(description ? description : "")}
            </Html>
          </View>
        )}
        <View
          style={{
            marginTop: 10,
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            width: pageWidth - 2 * paddingWidth + framePadding,
          }}
        >
          {phases.slice(0, cols).map((phase, index) => {
            let notesHTMLWithLinks = linkifyHtml(phase.note ? phase.note : "");

            return (
              <View
                key={"phase" + index}
                wrap={false}
                style={{
                  paddingRight: framePadding,
                  flexBasis: 100 / cols + "%",
                  flexGrow: 0,
                  flexShrink: 0,
                  paddingBottom: 20,
                }}
              >
                {printPhaseTitles && (
                  <View style={{ marginBottom: 8 }}>
                    <Text
                      style={{
                        fontSize: fontSizes.phaseTitle ?? 10,
                        fontWeight: "bold",
                        fontFamily: pdfFont,
                      }}
                    >
                      {Helper.getPhaseTitle(phase, phases, "output")}
                    </Text>
                  </View>
                )}
                <Phase
                  objectSizeFactor={objectSizeFactor}
                  maxHeight={maxHeight}
                  courtColor={courtColor}
                  width={frameWidth}
                  phase={phase}
                  court={court}
                />
                {printPhaseDescriptions && (
                  <View
                    style={{
                      marginTop: 15,
                      paddingRight: framePadding * 2,
                    }}
                  >
                    <Html
                      style={{ fontFamily: pdfFont }}
                      stylesheet={stylesheet(fontSizes.phase)}
                    >
                      {notesHTMLWithLinks}
                    </Html>
                  </View>
                )}
              </View>
            );
          })}
        </View>
      </View>

      <View
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          width: pageWidth - 2 * paddingWidth + framePadding,
        }}
      >
        {phases.slice(cols).map((phase, index) => {
          return (
            <View
              key={"phase" + index}
              wrap={false}
              style={{
                paddingRight: framePadding,
                flexBasis: 100 / cols + "%",
                flexGrow: 0,
                flexShrink: 0,
                paddingBottom: 20,
              }}
            >
              {printPhaseTitles && (
                <View style={{ marginBottom: 8 }}>
                  <Text
                    style={{
                      fontSize: fontSizes.phaseTitle ?? 10,
                      fontWeight: "bold",
                      fontFamily: pdfFont,
                    }}
                  >
                    {Helper.getPhaseTitle(phase, phases, "output")}
                  </Text>
                </View>
              )}
              <Phase
                objectSizeFactor={objectSizeFactor}
                maxHeight={maxHeight}
                courtColor={courtColor}
                width={frameWidth}
                phase={phase}
                court={court}
              />
              {printPhaseDescriptions && (
                <View
                  style={{
                    marginTop: 15,
                    paddingRight: framePadding * 2,
                  }}
                >
                  <Html
                    style={{ fontFamily: pdfFont }}
                    stylesheet={stylesheet(fontSizes.phase)}
                  >
                    {phase.note ? phase.note : ""}
                  </Html>
                </View>
              )}
            </View>
          );
        })}
      </View>
    </View>
  );
}
